import React, {useEffect, useState} from 'react'
import {
    Grid,
    Button,
    Segment,
    Icon,
    Form,
    Header,
    Table,
    Modal,
    Dimmer,
    Loader
} from "semantic-ui-react";
import Axios from "axios";
import objDefault from '../../../models/dischargeModel'
import moment from "moment";
import Constants from "../../../config/constants";

import {useHistory} from "react-router-dom";
import useStaff from "../../../hooks/useStaff";
import {DateInput} from "semantic-ui-calendar-react";

const dcStatus = [
    {key: '1', text: 'COMPLETE RECOVERY', value: '1'},
    {key: '2', text: 'IMPROVED', value: '2'},
    {key: '3', text: 'NOT IMPROVED', value: '3'},
    {key: '4', text: 'DEATH ,NO AUTOPSY', value: '4'},
    {key: '5', text: 'DEATH ,AUTOPSY', value: '5'}
]
const dcType = [
    {key: '6', text: 'WITH APPOVAL', value: '1'},
    {key: '7', text: 'AGAINST ADVICE', value: '2'},
    {key: '9', text: 'BY ESCAPE', value: '3'},
    {key: '8', text: 'BY TRANSFER', value: '4'},
    {key: '10', text: 'OTHER', value: '5'},
    {key: '11', text: 'DEATH', value: '6'}
]

const eyes = [
    {key: 4, text: 'Spontaneous (4)', value: 4},
    {key: 3, text: 'To sound (3)', value: 3},
    {key: 2, text: 'To pressure (2)', value: 2},
    {key: 1, text: 'None (1)', value: 1},
    {key: 0, text: 'Non-testable (NT) ', value: 1}
]
const verbal = [
    {key: 5, text: 'Orientated (5)', value: 5},
    {key: 4, text: 'Confused (4)', value: 4},
    {key: 3, text: 'Words (3)', value: 3},
    {key: 2, text: 'Sounds (2)', value: 2},
    {key: 1, text: 'None (1)', value: 1},
    {key: 0, text: 'Non-testable (NT)', value: '1'}
]
const best = [
    {key: 6, text: 'Obey commands (6)', value: 6},
    {key: 5, text: 'Localizing (5)', value: 5},
    {key: 4, text: 'Normal flexion (4)', value: 4},
    {key: 3, text: 'Abnormal flexion (3)', value: 3},
    {key: 2, text: 'Extension (2)', value: 2},
    {key: 1, text: 'None (1)', value: 1},
    {key: 0, text: 'Non-testable (NT)', value: 1}
]


const optionMechanism = [
    {key: 'b', text: 'Blunt', value: 'b'},
    {key: 'p', text: 'Penetrating', value: 'p'}
]

const Discharge = () => {
    const [input, setInput] = useState({
        ...objDefault
    });
    const [loading, setLoading] = useState(false);
    const history = useHistory()
    const { staff } = useStaff();
    const [users, setUsers] = useState([]);
    const [lists, setList] = React.useState([]);
    const [iss, setIss] = React.useState([]);
    const [dcUsers, setDcUsers] = useState([]);
    const [discharges, setDischarges] = useState([]);
    const [dcHistory, setDcHistory] = useState([]);
    const [user, setUser] = useState({});
    const [inputList, setInputList] = useState([]);
    const [open, setOpen] = React.useState(false)
    const [inputText, setInputText] = useState({
        text_head: 'เกิดข้อผิดพลาด',
        text_description: 'กรุณาติดต่อผู้ดูแลระบบ',
        text_error: [],
        principal_diagnosis: false,
        mechanism_injury: false
    });
    const handleValueChange = (e) => {
        const {
            name, value
        } = e.target;
        setInput((prevInput) => ({
            ...prevInput,
            [name]: value,
        }))

        calcTriss(name,value)
    };


    const navigateToBasket = (fullPath) => {
        history.push(fullPath);
    }
    const handleValidate = () => {
        setInputText((prevInput) => ({
            ...prevInput,
            principal_diagnosis: !!!input.principal_diagnosis ? 'require' : false,
            mechanism_injury: !!!input.mechanism_injury ? 'require' : false,
        }))
    }
    useEffect(() => {
        const init = async () => {
            setLoading(true);
            try {
                const search = window.location.search;
                const params = new URLSearchParams(search);
                const admission_id = params.get('admission_id');
                await getAis();

                if (admission_id) {
                    await getAisDischarge(admission_id);
                    await getDischargeAdmissionById(admission_id);
                }
            } catch (e) {
                console.error(e);
            } finally {
                setLoading(false);
            }
        };
        init();
    }, []);

    const handleInputChange = (e, index) => {
        const {name, value} = e.target;
        const list = [...inputList];
        list[index][name] = value;
        setInputList(list);
    };

// handle click event of the Remove button
    const handleRemoveClick = (e, i) => {
        const list = [...inputList];
        list.splice(i, 1);
        setInputList(list);
    };

// handle click event of the Add button
    const handleAddClick = () => {
        setInputList([...inputList, {iss_id: ""}]);
    };

    const calcTriss = (name, value,iss = null,e = null) => {

        let _iss = input.iss
        if(e === 'c')
             _iss = iss

        let b0 = 0
        let b1 = 0
        let b2 = 0
        let b3 = 0
        let ageIndex = (input.age)<50?0:1;
        let calc = 0

        if (name == 'mechanism_injury' && value == 'b' ) {
            b0 = -0.4499
            b1 = 0.8085
            b2 = -0.0835
            b3 = -1.7430
            calc = 1
        }

        if (name == 'mechanism_injury' && value == 'p' ) {
            b0 = -2.5355
            b1 = 0.9934
            b2 = -0.0651
            b3 = -1.1360
            calc = 1
        }

        if(input.age < 15){
            b0 = -0.4499
            b1 = 0.8085
            b2 = -0.0835
            b3 = -1.7430
            calc = 1
        }

        if (calc == 1)
        {
            let b = (b0) + (b1 * input.rts) + (b2 * _iss) + (b3 * ageIndex)
            let ps = 1 / (1 + Math.pow(Math.E, -b))
            setInput((prevInput) => ({
                ...prevInput,
                triss: (ps * 100).toFixed(1)
            }))
        }
    }

    const calcRTS = (name = null, value = null) => {
        let arr = []

        arr[0] = input.bp ? parseInt(input.bp) : 0;
        arr[1] = input.rr ? parseInt(input.rr) : 0;
        arr[2] = input.gcs_e ? parseInt(input.gcs_e) : 0;
        arr[3] = input.gcs_v ? parseInt(input.gcs_v) : 0;
        arr[4] = input.gcs_m ? parseInt(input.gcs_m) : 0;
        if (name == 'bp' && value > 0) {
            arr[0] = parseInt(value)
        }
        if (name == 'rr' && value > 0) {
            arr[1] = parseInt(value)

        }
        if (name == 'gcs_e' && value > 0) {
            arr[2] = parseInt(value)
        }
        if (name == 'gcs_v' && value > 0) {
            arr[3] = parseInt(value)
        }
        if (name == 'gcs_m' && value > 0) {
            arr[4] = parseInt(value)
        }
        arr[2] = arr[2] + arr[3] + arr[4]

        let gsc = 0
        let sbp = 0
        let rr = 0
        if (arr[0] > 89) {
            sbp = 4
        } else if (arr[0] >= 76 && arr[0] <= 89) {
            sbp = 3
        } else if (arr[0] >= 50 && arr[0] <= 75) {
            sbp = 2
        } else if (arr[0] >= 1 && arr[0] <= 49) {
            sbp = 1
        } else {
            sbp = 0
        }

        if (arr[1] > 29) {
            rr = 3
        } else if (arr[1] >= 10 && arr[1] <= 29) {
            rr = 4
        } else if (arr[1] >= 6 && arr[1] <= 9) {
            rr = 2
        } else if (arr[1] >= 1 && arr[1] <= 5) {
            rr = 1
        } else {
            rr = 0
        }
        if (arr[2] >= 13) {
            gsc = 4
        } else if (arr[2] >= 9 && arr[2] <= 12) {
            gsc = 3
        } else if (arr[2] >= 6 && arr[2] <= 8) {
            gsc = 2
        } else if (arr[2] >= 4 && arr[2] <= 5) {
            gsc = 1
        } else {
            gsc = 0
        }

        let resRTS = (0.9368 * gsc) + (0.7326 * sbp) + (0.2908 * rr)

        setInput((prevInput) => ({
            ...prevInput,
            rts: parseFloat(resRTS.toFixed(3))
        }))

    }
    const calcRTSadmission = (_gsc, _rr, _sbp) => {

        let gsc, rr, sbp

        if (_sbp > 89) {
            sbp = 4
        } else if (_sbp >= 76 && _sbp <= 89) {
            sbp = 3
        } else if (_sbp >= 50 && _sbp <= 75) {
            sbp = 2
        } else if (_sbp >= 1 && _sbp <= 49) {
            sbp = 1
        } else {
            sbp = 0
        }

        if (_rr > 29) {
            rr = 3
        } else if (_rr >= 10 && _rr <= 29) {
            rr = 4
        } else if (_rr >= 6 && _rr <= 9) {
            rr = 2
        } else if (_rr >= 1 && _rr <= 5) {
            rr = 1
        } else {
            rr = 0
        }
        if (_gsc >= 13) {
            gsc = 4
        } else if (_gsc >= 9 && _gsc <= 12) {
            gsc = 3
        } else if (_gsc >= 6 && _gsc <= 8) {
            gsc = 2
        } else if (_gsc >= 4 && _gsc <= 5) {
            gsc = 1
        } else {
            gsc = 0
        }
      //  alert(_gsc+'-'+_rr+'-'+_sbp)
        let resRTS = (0.9368 * gsc) + (0.7326 * sbp) + (0.2908 * rr)
      //  alert(resRTS)

        setInput((prevInput) => ({
            ...prevInput,
            rts: parseFloat(resRTS.toFixed(3))
        }))
    }

    function openInNewTab(id, path) {
        var win = window.open(path + id, '_blank');
        win.focus();
    }

    const navigateTo = (id, path) => {
        history.push(path + id);
    }


    const saveDischarge = async () => {
        setLoading(true);
        try {
            handleValidate()
            let iss_score = await calcIssrealtime()
            if(input.iss !== iss_score){
                input.iss = iss_score
            }

            let result = await Axios.post('http://' + Constants.url + ':' + Constants.port + '/v1/snr/discharge',
                {
                    admission_date: input.admission_date,
                    discharge_date: input.discharge_date,
                    discharge_status: input.discharge_status,
                    discharge_type: input.discharge_type,
                    history: input.history,
                    chief_complaint: input.chief_complaint,
                    hr: input.hr,
                    rr: input.rr,
                    bp_s: input.bp_s,
                    bp_d: input.bp_d,
                    bt: input.bt,
                    sat: input.sat,
                    other: input.other,
                    gcs_e: input.gcs_e,
                    gcs_v: input.gcs_v,
                    gcs_m: input.gcs_m,
                    inv_eFAST: input.inv_eFAST,
                    inv_p_cxr: input.inv_p_cxr,
                    inv_other: input.inv_other,
                    management: input.management,
                    operation: input.operation,
                    findings: input.findings,
                    principal_diagnosis: input.principal_diagnosis,
                    other_problems: input.other_problems,
                    hosital_course: input.hosital_course,
                    complication: input.complication,
                    home_medications: input.home_medications,
                    appointment: input.appointment,
                    mechanism_injury: input.mechanism_injury,
                    admission_id: input.admission_id,
                    patient_id: input.patient_id,
                    iss: input.iss,
                    rts: input.rts,
                    triss: input.triss,
                    discharge_id: input.discharge_id,
                    iss_detail: inputList,
                    ward: input.ward,
                    staff_id: input.staff_id,
                    resident_name: input.resident_name,
                    division: input.division,
                    record_name: input.record_name,
                    recode_code: input.recode_code,
                    record_datetime: input.record_datetime
                },{
                    headers: {
                        Authorization: Constants.headerAuthorization,
                        'Content-Type': 'application/json'
                    }
                }
            );



            if (result.data.message === 'Missing require field') {
                setInputText((prevInput) => ({
                    ...prevInput,
                    text_head: 'เกิดข้อผิดพลาด',
                    text_description: result.data.message,
                    text_error: result.data.message_description
                }))
            } else {

                setInputText((prevInput) => ({
                    ...prevInput,
                    text_head: 'ทำรายการสำเร็จ',
                    text_description: result.data.data.message,
                    text_error : []
                }))

                setInput((prevInput) => ({
                    ...prevInput,
                    discharge_id: result.data.data.id,
                }))

            }

            setOpen(true)
        } catch (e) {
            console.log(e)
            setOpen(true)
            setInputText((prevInput) => ({
                ...prevInput,
                text_head: 'เกิดข้อผิดพลาด',
                text_description: 'กรุณาติดต่อผู้ดูแลระบบ',
                text_error: []
            }))

        } finally {
            setLoading(false);
        }
    }


    const getAis = async () => {

        let res = await Axios.get('http://' + Constants.url + ':' + Constants.port + '/v1/snr/aiscode',{
            headers: {
                Authorization: Constants.headerAuthorization,
                'Content-Type': 'application/json'
            }
        });
        setList(res.data.data);
    }
    const getAisDischarge = async (admissionId) => {
        let res = await Axios.get('http://' + Constants.url + ':' + Constants.port + '/v1/snr/aiscode?admission_id=' + admissionId,{
            headers: {
                Authorization: Constants.headerAuthorization,
                'Content-Type': 'application/json'
            }
        });
        setInputList(res.data.data);

    }

    const calcIssrealtime = async () => {
        try {
            let res = await Axios.post('http://' + Constants.url + ':' + Constants.port + '/v1/snr/aiscode',
                {
                    iss_detail: inputList,
                },{
                    headers: {
                        Authorization: Constants.headerAuthorization,
                        'Content-Type': 'application/json'
                    }
                }

            );
            setInput((prevInput) => ({
                ...prevInput,
                iss: res.data.data.iss
            }))
            let name
            if (input.mechanism_injury == 'b' ) {
                name = 'mechanism_injury'
            }

            if (input.mechanism_injury == 'p' ) {
                name = 'mechanism_injury'
            }

            calcTriss(name,input.mechanism_injury,res.data.data.iss,'c')
            return  res.data.data.iss;

        }catch (e) {

        }

    }



    const getDischargeById = async (discharge_id) => {
        try {
            let dc_data = await Axios.get('http://' + Constants.url + ':' + Constants.port + '/v1/snr/discharge?discharge_id=' + discharge_id,{
                headers: {
                    Authorization: Constants.headerAuthorization,
                    'Content-Type': 'application/json'
                }
            });

            let response = dc_data.data.data[0]
            console.log(response)

            setInput((prevInput) => ({
                ...prevInput,
                discharge_id: discharge_id,
                name: response.name,
                surname: response.surname,
                address: response.address,
                citizen_id: response.citizen_id,
                gender: response.gender,
                id: response.id,
                admission_date: !!response.admission_date ? moment(response.admission_date).format("DD-MM-YYYY") : null,
                discharge_date: !!response.discharge_date ? moment(response.discharge_date).format("DD-MM-YYYY") : moment(new Date()).format("DD-MM-YYYY"),
                discharge_status: response.discharge_status,
                discharge_type: response.discharge_type,
                // history: response.history,
                // chief_complaint: response.dc_chief_complaint,
                // hr: response.hr,
                // pr: response.pr,
                // rr: response.discharge_rr,
                // bp: response.bp,
                // bt: response.bt,
                // sat: response.sat,
                // other: response.other,
                // gcs_e: response.gcs_e,
                // gcs_v: response.gcs_v,
                // gcs_m: response.gcs_m,
                // inv_eFAST: response.inv_eFAST,
                // inv_p_cxr: response.inv_p_cxr,
                // inv_other: response.inv_other,
                management: response.management,
                operation: response.operation,
                findings: response.findings,
                principal_diagnosis: response.principal_diagnosis,
                other_problems: response.other_problems,
                hosital_course: response.hosital_course,
                complication: response.complication,
                home_medications: response.home_medications,
                appointment: response.appointment,
                mechanism_injury: response.mechanism_injury,
                admission_id: response.admission_id,
                iss: response.iss,
                patient_id: response.patient_id,
              //  rts: !!!input.rts ? response.rts : input.rts,
                triss: !!!input.triss ? response.triss : input.triss,
                ward: response.ward,
                staff_id:  parseInt(response.staff_id),
                resident_name: response.resident_name,
                division: response.division,
                record_name: response.record_name,
                recode_code: response.recode_code,
                record_datetime :  response.record_datetime?moment(response.record_datetime).format("DD-MM-YYYY H:mm:ss") : moment(new Date()).format("DD-MM-YYYY H:mm:ss")
            }))



        } catch (e) {
            console.log(e);
        }

    }
    const getDischargeAdmissionById = async (admission_id) => {
        try {

            let admission_data = await Axios.get('http://' + Constants.url + ':' + Constants.port + '/v1/snr/admission?id=' + admission_id,{
                headers: {
                    Authorization: Constants.headerAuthorization,
                    'Content-Type': 'application/json'
                }
            });
            let response = admission_data.data.data[0]
            setInput((prevInput) => ({
                ...prevInput,
                discharge_id: response.discharge_id,
                name: response.name,
                surname: response.surname,
                address: response.address,
                citizen_id: response.citizen_id,
                gender: response.gender,
                age:response.age,
                id: response.id,
                admission_date: !!response.admission_date ? moment(response.admission_date).format("DD-MM-YYYY") : null,
                discharge_date: !!response.discharge_date ? moment(response.discharge_date).format("DD-MM-YYYY") : moment(new Date()).format("DD-MM-YYYY"),
                discharge_status: response.discharge_status,
                discharge_type: response.discharge_type,
                history: response.history,
                chief_complaint: response.chief_complaint,
                hr: response.hr,
                pr: response.pr,
                rr: response.rr,
                bt: response.bt,
                sat: response.sat,
                other: response.other,
                gcs_e: response.gcs_e,
                gcs_v: response.gcs_v,
                gcs_m: response.gcs_m,
                inv_eFAST: response.inv_eFAST,
                inv_p_cxr: response.inv_p_cxr,
                inv_other: response.inv_other,
                management: response.management,
                operation: response.operation,
                findings: response.findings,
                principal_diagnosis: response.principal_diagnosis,
             //   other_problems: response.other_problems,
                hosital_course: response.hosital_course,
                complication: response.complication,
                home_medications: response.home_medications,
                appointment: response.appointment,
                iss_head: response.iss_head,
                iss_chest: response.iss_chest,
                iss_external: response.iss_external,
                iss_face: response.iss_face,
                iss_abdomen: response.iss_abdomen,
                iss_extremity: response.iss_extremity,
                iss_rr: response.iss_rr,
                mechanism_injury: response.mechanism_injury,
                admission_id: response.admission_id,
                patient_id: response.patient_id,
                hn: response.hn,
                blood_group: response.blood_group,
                rh: response.rh,
                an: response.an,
                ward: response.ward,
                staff_name: response.staff_name,
                resident_name: response.resident_name,
                division: response.division,
                record_name: response.record_name,
                recode_code: response.recode_code,
                bp_d: response.bp_d,
                bp_s: response.bp_s,
                iss_sbp: response.bp_s,
                staff_id:parseInt(response.staff_id)
            }))

            let _gsc = parseInt(response.gcs_e) + parseInt(response.gcs_v) + parseInt(response.gcs_m)

            calcRTSadmission(_gsc, response.rr, response.bp_s)

            if (response.discharge_id) {
                await getDischargeById(response.discharge_id)
            }
        } catch (e) {
            console.log(e);
        }
    }

    return (
        <div style={{display: "flex", minHeight: "90vh", flexDirection: "column"}}>

            <div style={{flex: 1, position: 'relative'}}>
                <Dimmer active={loading} inverted>
                    <Loader size='large'>กำลังโหลดข้อมูล...</Loader>
                </Dimmer>
                <Grid style={{marginTop: "5em", marginLeft: "2em"}}>
                    {
                        input.admission_id ?
                            <>

                                <Grid.Row>
                                    <Grid.Column width={8}>
                                        <Segment color='teal' raised>
                                            <Header as='h3' dividing>

                                                <Button color='teal'
                                                        onClick={() => navigateTo(input.admission_id, '/admission?id=')}
                                                       >
                                                    <Icon name={'file alternate outline'}></Icon> Admission note
                                                </Button>
                                                <Button color='red'
                                                        onClick={() => openInNewTab(input.discharge_id, '/discharge/pdf?discharge_id=')}
                                                       >
                                                    <Icon name={'file pdf'}></Icon> Discharge summary

                                                </Button>
                                                <Button color='teal'
                                                        onClick={() => navigateTo(input.admission_id, '/opnote?admission_id=')}
                                                       >
                                                    <Icon name={'clipboard'}></Icon> Operation note
                                                </Button>
                                                <Button color='teal'
                                                        onClick={() => navigateToBasket(`/basket?admission_id=${input.admission_id}&patient_id=${input.patient_id}`)}
                                                        key={input.admission_id}>
                                                    <Icon name={'image'}></Icon>Picture basket
                                                </Button>

                                            </Header>
                                        </Segment>
                                    </Grid.Column>
                                </Grid.Row>
                            </>
                            : ''
                    }
                    <Grid.Row>

                        <Grid.Column width={15}>

                            <Segment color='teal' raised>
                                <Header as='h3' block>
                                    ข้อมูลผู้ป่วย :
                                    HN {input.hn} AN {input.an} ชื่อ {input.name} {input.surname} หมู่เลือด {input.blood_group} RH {input.rh}

                                </Header>

                                <Form>

                                    <Form.Group widths='equal'>
                                        <DateInput
                                            name="admission_date"
                                            placeholder="Date"
                                            value={input.admission_date}
                                            label='วันที่ admission'
                                            iconPosition="right"

                                            onChange={(e, {name, value}) => handleValueChange({target: {name, value}})}

                                        />
                                        <DateInput
                                            name="discharge_date"
                                            placeholder="Date"
                                            value={input.discharge_date}
                                            label='วันที่ Discharge '
                                            iconPosition="right"
                                            onChange={(e, {name, value}) => handleValueChange({target: {name, value}})}
                                            required={true}
                                        />
                                        <Form.Select
                                            fluid label='Discharge status'
                                            name='discharge_status'
                                            value={input.discharge_status}
                                            placeholder='Discharge status'
                                            options={dcStatus}
                                            onChange={(e, {name, value}) => handleValueChange({target: {name, value}})}
                                            required={true}
                                        />
                                        <Form.Select
                                            fluid label='Discharge Type'
                                            name='discharge_type'
                                            value={input.discharge_type}
                                            options={dcType}
                                            placeholder='Discharge Type'
                                            onChange={(e, {name, value}) => handleValueChange({target: {name, value}})}
                                            required={true}
                                        />


                                    </Form.Group>

                                    <Form.Group widths='equal'>
                                        <Form.Input
                                            fluid label='Chief complaint'
                                            name='chief_complaint'
                                            value={input.chief_complaint}
                                            placeholder='Chief complaint'
                                            onChange={(e) => handleValueChange(e)}
                                            disabled={true}


                                        />

                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                        <Form.Input
                                            fluid label='History'
                                            name='history'
                                            value={input.history}
                                            placeholder='History'
                                            disabled={true}
                                            onChange={(e) => handleValueChange(e)}
                                        />

                                    </Form.Group>
                                    <Header as='h3' color='blue' dividing>
                                        Physical examinations
                                    </Header>
                                    <Form.Group widths='equal'>

                                        <Form.Input
                                            fluid label='HR'
                                            name='hr'
                                            value={input.hr}
                                            placeholder='HR'
                                            onChange={(e) => handleValueChange(e)}
                                            disabled={true}
                                        />
                                        <Form.Input
                                            fluid label='RR'
                                            name='rr'
                                            value={input.rr}
                                            placeholder='RR'
                                            onChange={(e) => handleValueChange(e)}
                                            disabled={true}
                                        />
                                        <Form.Input
                                            fluid label='BT'
                                            name='bt'
                                            value={input.bt}
                                            placeholder='BT'
                                            onChange={(e) => handleValueChange(e)}
                                            disabled={true}
                                        />
                                        <Form.Input
                                            fluid label='Systolic BP'
                                            name='bp_s'
                                            value={input.bp_s}
                                            type={'number'}
                                            placeholder='Systolic BP'
                                            onChange={(e) => handleValueChange(e)}

                                            disabled={true}
                                        />
                                        <Form.Input
                                            fluid label='Diastolic BP'
                                            name='bp_d'
                                            value={input.bp_d}
                                            type={'number'}
                                            placeholder='Diastolic BP'
                                            onChange={(e) => handleValueChange(e)}

                                            disabled={true}
                                        />

                                        <Form.Input
                                            fluid label='Sat (%)'
                                            name='sat'
                                            value={input.sat}
                                            placeholder='SAT'
                                            onChange={(e) => handleValueChange(e)}
                                            disabled={true}
                                        />
                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                        <Form.Input
                                            fluid
                                            name='other'
                                            value={input.other}
                                            placeholder='Other'
                                            onChange={(e) => handleValueChange(e)}
                                        />
                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                        <Form.Select
                                            fluid label='Eye opening (E)'
                                            name='gcs_e'
                                            value={input.gcs_e}
                                            placeholder='Eye opening (E)'
                                            options={eyes}
                                            onChange={(e, {name, value}) => handleValueChange({target: {name, value}})}
                                            required={true}
                                            disabled={true}
                                        />

                                        <Form.Select
                                            fluid label='Verbal response (V)'
                                            name='gcs_v'
                                            value={input.gcs_v}
                                            placeholder='Verbal response (V)'
                                            options={verbal}
                                            onChange={(e, {name, value}) => handleValueChange({target: {name, value}})}
                                            required={true}
                                            disabled={true}
                                        />

                                        <Form.Select
                                            fluid label='Motor response (M)'
                                            name='gcs_m'
                                            value={input.gcs_m}
                                            placeholder='Motor response (M)'
                                            options={best}
                                            onChange={(e, {name, value}) => handleValueChange({target: {name, value}})}
                                            required={true}
                                            disabled={true}
                                        />

                                    </Form.Group>
                                    <Header as='h3' color='blue' dividing>
                                        Investigations
                                    </Header>
                                    <Form.Group widths='equal'>

                                        <Form.Input
                                            fluid label='eFAST'
                                            name='inv_eFAST'
                                            value={input.inv_eFAST}
                                            placeholder='eFAST'
                                            onChange={(e) => handleValueChange(e)}
                                            disabled={true}
                                        />
                                        <Form.Input
                                            fluid label='P-CXR'
                                            name='inv_p_cxr'
                                            value={input.inv_p_cxr}
                                            placeholder='P-CXR'
                                            onChange={(e) => handleValueChange(e)}
                                            disabled={true}
                                        />
                                        <Form.Input
                                            fluid label='Others'
                                            name='inv_other'
                                            value={input.inv_other}
                                            placeholder='Others'
                                            onChange={(e) => handleValueChange(e)}

                                        />
                                    </Form.Group>
                                    <Header as='h3' color='blue' dividing>
                                        Management
                                    </Header>

                                    <Form.Group widths='equal'>

                                        <Form.Input
                                            fluid
                                            name='management'
                                            value={input.management}
                                            placeholder='Management'
                                            onChange={(e) => handleValueChange(e)}
                                        />
                                        <Form.Input
                                            fluid
                                            name='operation'
                                            value={input.operation}
                                            placeholder='Operation'
                                            onChange={(e) => handleValueChange(e)}
                                        />
                                        <Form.Input
                                            fluid
                                            name='findings'
                                            value={input.findings}
                                            placeholder='Findings'
                                            onChange={(e) => handleValueChange(e)}
                                        />
                                    </Form.Group>
                                    <Header as='h3' color='blue' dividing>
                                        Diagnosis
                                    </Header>

                                    <Form.Group widths='equal'>

                                        <Form.Input
                                            fluid label='Admission diagnosis'
                                            name='principal_diagnosis'
                                            value={input.principal_diagnosis}
                                            placeholder='Principal diagnosis'
                                            onChange={(e) => handleValueChange(e)}
                                            error={inputText.principal_diagnosis}
                                        />
                                        <Form.Input
                                            fluid label='Other diagnosis'
                                            name='other_problems'
                                            value={input.other_problems}
                                            placeholder='Operation'
                                            onChange={(e) => handleValueChange(e)}
                                        />

                                    </Form.Group>
                                    <Form.Group widths='equal'>

                                        <Form.TextArea
                                            fluid label='Hospital course'
                                            name='hosital_course'
                                            rows={8}
                                            value={input.hosital_course}
                                            placeholder='Hospital course'
                                            onChange={(e) => handleValueChange(e)}
                                        />


                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                        <Form.Input
                                            fluid label='Complication'
                                            name='complication'
                                            value={input.complication}
                                            placeholder='None'
                                            onChange={(e) => handleValueChange(e)}
                                        />
                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                        <Form.TextArea
                                            fluid label='Home medications'
                                            name='home_medications'
                                            value={input.home_medications}
                                            placeholder='Home medications'
                                            onChange={(e) => handleValueChange(e)}
                                        />
                                    </Form.Group>
                                    <Form.Group>
                                        <DateInput
                                            name="appointment"
                                            placeholder="Date"
                                            value={input.appointment}
                                            label='วันที่ Appointment'
                                            iconPosition="right"

                                            onChange={(e, {name, value}) => handleValueChange({target: {name, value}})}

                                        />

                                    </Form.Group>
                                    <Header as='h3' color='blue' dividing>
                                        ISS
                                    </Header>


                                    {inputList.map((x, i) => {
                                        return (
                                            <Form.Group key={x.iss_id}>
                                                <Form.Dropdown
                                                    width={12}
                                                    placeholder='diagnosis'
                                                    fluid label={'iss-name'}
                                                    search
                                                    selection
                                                    name="iss_id"
                                                    value={x.iss_id}
                                                    options={lists}
                                                    onChange={(e, {name, value}) => handleInputChange({
                                                        target: {
                                                            name,
                                                            value
                                                        }
                                                    }, i)}
                                                />
                                                <Form.Button width={3} style={{marginTop: '24px'}}
                                                             onClick={(e) => handleRemoveClick(e, i)}><Icon
                                                    name='delete'/> ลบ</Form.Button>
                                            </Form.Group>
                                        );
                                    })}
                                    <Form.Group>
                                    <Form.Button onClick={handleAddClick}><Icon name='plus'/> Add</Form.Button>
                                        <Form.Button onClick={(e)=>calcIssrealtime(e)} ><Icon name='calculator'/> Calculator iss </Form.Button>
                                    </Form.Group>

                                    <Table celled structured>
                                        <Table.Header>
                                            <Table.Row>
                                                <Table.HeaderCell textAlign='center' colSpan='9'>Trauma and Injury
                                                    Severity Score (TRISS) Calculator</Table.HeaderCell>

                                            </Table.Row>
                                        </Table.Header>

                                        <Table.Body>

                                            <Table.Row>

                                                <Table.Cell textAlign='center'>
                                                    ISS
                                                </Table.Cell>
                                                <Table.Cell colspan={'8'}>
                                                    <Form.Input

                                                        size='mini'
                                                        name='iss'
                                                        value={input.iss}
                                                        placeholder='ISS'
                                                        readOnly={'readOnly'}
                                                        onChange={(e) => handleValueChange(e)}
                                                    />
                                                </Table.Cell>
                                            </Table.Row>

                                            <Table.Row>
                                                <Table.Cell>Revised Trauma Score</Table.Cell>

                                                <Table.Cell>SBP</Table.Cell>
                                                <Table.Cell textAlign='right'>
                                                    <Form.Input

                                                        size='mini'
                                                        name='iss_sbp'
                                                        value={input.iss_sbp}
                                                        placeholder='SBP'
                                                        onChange={(e) => handleValueChange(e)}
                                                        readOnly={'readOnly'}
                                                    />
                                                </Table.Cell>
                                                <Table.Cell textAlign='center'>
                                                    RR
                                                </Table.Cell>
                                                <Table.Cell textAlign='right'>
                                                    <Form.Input

                                                        size='mini'
                                                        name='iss_rr'
                                                        value={input.rr}
                                                        placeholder='RR'
                                                        onChange={(e) => handleValueChange(e)}
                                                        readonly={'readOnly'}
                                                    />
                                                </Table.Cell>
                                                <Table.Cell textAlign='center'>
                                                    GCS
                                                </Table.Cell>
                                                <Table.Cell textAlign='right'>
                                                    <Form.Input

                                                        size='mini'
                                                        name='iss_gsc'
                                                        placeholder='GCS'
                                                        value={parseInt(input.gcs_e) + parseInt(input.gcs_v) + parseInt(input.gcs_m)}
                                                        onChange={(e) => handleValueChange(e)}
                                                        readonly={'readOnly'}
                                                    />
                                                </Table.Cell>
                                                <Table.Cell textAlign='center'>
                                                    RTS
                                                </Table.Cell>
                                                <Table.Cell>
                                                    <Form.Input
                                                        size='mini'
                                                        name='rts'
                                                        value={input.rts}
                                                        readOnly={'readOnly'}
                                                        placeholder='RTS'
                                                        onChange={(e) => handleValueChange(e)}
                                                    />
                                                </Table.Cell>

                                            </Table.Row>
                                            <Table.Row>
                                                <Table.Cell rowSpan='3'>TRISS</Table.Cell>
                                                <Table.Cell rowspan="3" colspan="2">Mechanism of injury</Table.Cell>
                                                <Table.Cell rowspan="3" colspan="2" textAlign='right'>

                                                    <Form.Select

                                                        name='mechanism_injury'
                                                        size='mini'
                                                        value={input.mechanism_injury}
                                                        placeholder='Mechanism of injury'
                                                        options={optionMechanism}
                                                        error={inputText.mechanism_injury}
                                                        required={true}
                                                        onChange={(e, {name, value}) => handleValueChange({
                                                            target: {
                                                                name,
                                                                value
                                                            }
                                                        })}

                                                    />
                                                </Table.Cell>

                                                <Table.Cell rowspan="3" textAlign='center'>
                                                    Age = {input.age}
                                                </Table.Cell>


                                                <Table.Cell rowSpan='3' colspan="3">Probability of survival
                                                    = {input.triss} % </Table.Cell>
                                            </Table.Row>

                                        </Table.Body>
                                    </Table>

                                    <Header as='h3' dividing color='blue'>
                                        Record information
                                    </Header>
                                    <Form.Group widths='equal'>
                                        <Form.Input

                                            fluid label='Ward'
                                            name='ward'
                                            value={input.ward}
                                            placeholder='ward'
                                            onChange={(e) => handleValueChange(e)}
                                        />
                                        <Form.Select

                                            fluid label='Staff'
                                            name='staff_id'
                                            value={input.staff_id}
                                            options={staff}
                                            placeholder='Staff'
                                            onChange={(e, {name, value}) => handleValueChange({target: {name, value}})}
                                            required={true}
                                        />

                                        <Form.Input

                                            fluid label='Resident'
                                            name='resident_name'
                                            value={input.resident_name}
                                            placeholder='Resident'
                                            onChange={(e) => handleValueChange(e)}
                                        />
                                        <Form.Input

                                            fluid label='division'
                                            name='division'
                                            value={input.division}
                                            placeholder='division'
                                            onChange={(e) => handleValueChange(e)}
                                            disabled={true}
                                        />

                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                        <Form.Input

                                            fluid label='ผู้บันทึก'
                                            name='record_name'
                                            value={input.record_name}
                                            placeholder='ผู้บันทึก'
                                            onChange={(e) => handleValueChange(e)}
                                        />
                                        <Form.Input

                                            fluid label='รหัสผู้บันทึก'
                                            name='recode_code'
                                            value={input.recode_code}
                                            placeholder='รหัสผู้บันทึก ex.SU63999'
                                            onChange={(e) => handleValueChange(e)}
                                        />



                                        <Form.Input

                                            fluid label='วันเวลาที่บันทึก'
                                            name='record_datetime'
                                            value={input.record_datetime}
                                            placeholder='วันเวลาที่บันทึก'
                                            onChange={(e, {name, value}) => handleValueChange({target: {name, value}})}
                                            required={'true'}
                                            disabled={true}
                                        />
                                    </Form.Group>


                                    <Form.Button color='blue'
                                                 onClick={() => saveDischarge()}
                                    ><Icon name='plus'/> บันทึก Discharge</Form.Button>
                                </Form>

                            </Segment>

                        </Grid.Column>
                    </Grid.Row>

                </Grid>
            </div>
            <Modal
                centered={false}
                open={open}
                onClose={() => setOpen(false)}
                onOpen={() => setOpen(true)}
                style={{height: 'auto', left: 'auto'}}

            >
                <Modal.Header>{inputText.text_head}</Modal.Header>
                <Modal.Content>
                    <Modal.Description>
                        {inputText.text_description}
                    </Modal.Description>
                    {
                        inputText.text_error.length > 0 && inputText.text_error.map((v, i) => (
                            <Modal.Description key={i}><b style={{color: 'red'}}>{v}</b></Modal.Description>
                        ))
                    }
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={() => setOpen(false)}>OK</Button>
                </Modal.Actions>
            </Modal>
        </div>
    );
}

export default Discharge;
